import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AuthService } from '../../../authentification/login/service';
import { EChangeTarget } from '../../../shared/enums/EChangeTarget';
import { formatDate } from '../../../shared/functions/formatDate';
import { handleError } from '../../../shared/functions/handleError';
import { IChangeTarget } from '../../../shared/interfaces/IChangeTarget';
import { ITrailer } from '../../../shared/interfaces/ITrailer';

interface IProps {
  trailerId: string | number;
}

const TrailerPreview = ({ trailerId }: IProps) => {
  const { t } = useTranslation();
  const [data, setData] = useState<IChangeTarget<ITrailer> | undefined>(
    undefined,
  );

  const renderField = (field: keyof ITrailer, isAfter = false) => {
    const beforeValue = data?.before?.[field];
    const afterValue = data?.after?.[field];
    const label = t(`general.${field}`);
    const changed = beforeValue !== afterValue;

    return (
      <div
        key={field + (isAfter ? '-after' : '-before')}
        className="d-flex align-items-center mb-1"
      >
        <p className="fw-bold mb-0">{label}</p>:
        <span
          className={`ms-1 ${changed && isAfter ? 'text-warning fw-semibold' : ''}`}
        >
          {(isAfter ? afterValue : beforeValue) as string}
        </span>
      </div>
    );
  };

  useEffect(() => {
    if (trailerId) {
      AuthService.getChangeTarget<ITrailer>({
        targetId: String(trailerId),
        target: EChangeTarget.TRAILER,
      })
        .then(setData)
        .catch(handleError);
    }
  }, [trailerId]);

  return (
    <Row>
      {data && (
        <>
          <Col md={6} className="border-end">
            <h5 className="mb-3 fw-bold">{t('general.oldData')}:</h5>

            {renderField('licensePlate')}
            {renderField('technicalInspection')}
            {renderField('frc')}
          </Col>
          <Col md={6}>
            <h5 className="mb-3 fw-bold">{t('general.newData')}:</h5>
            {renderField('licensePlate', true)}
            {renderField('technicalInspection', true)}
            {renderField('frc', true)}
          </Col>
          <Col md={12} className="border-top pt-3">
            <div className="d-flex align-items-center">
              <h6 className="fw-bold">{t('general.requestedBy')}</h6>
              <span className="mx-1">- {data?.changedBy?.displayName} -</span>
              {formatDate(data?.updatedAt as string, 'DD.MM.YYYY HH:mm:ss')}
            </div>
          </Col>
        </>
      )}
    </Row>
  );
};

export default TrailerPreview;
